import script from "./MessageBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBox.vue?vue&type=script&setup=true&lang=js"

import "./MessageBox.vue?vue&type=style&index=0&id=dae033ac&lang=scss"

const __exports__ = script;

export default __exports__